import { VideoSegmentStatus } from '@eagle/data-function-types';
import { Chip, styled, Typography } from '@ethings/ui-toolkit';
import { useTheme } from '@mui/material';
import { SxProps } from '@mui/system';
import chroma from 'chroma-js';
import { ComponentProps, FC, ReactNode } from 'react';
import { useResponsiveText } from '../../hooks';
import { innerText } from '../../util';
import { VideoCellIcon } from './video-cell-icon';

interface Props {
  fontSize?: string;
  label: ReactNode | string;
  sx?: SxProps;
  videoCellStatus: VideoSegmentStatus;
}

interface StyledChipProps extends ComponentProps<typeof Chip> {
  sx?: SxProps;
}

const StyledChip = styled(Chip)<StyledChipProps>(({ theme }) => ({
  backgroundColor: '#e0e0e0',
  color: chroma(theme.palette.common.black).alpha(0.87).css(),
  paddingLeft: theme.spacing(0.5),
}));

export const VideoCellChip: FC<Props> = ({ fontSize, label, sx, videoCellStatus }) => {
  const theme = useTheme();

  const labelLength = innerText(label).length;
  const baseSize = fontSize ?? '0.6rem';
  const labelStyles = useResponsiveText(baseSize, labelLength, {
    minFontSize: '0.55rem',
    maxFontSize: baseSize,
    textLengthThreshold: 20,
  });

  return <StyledChip
    icon={<VideoCellIcon color={chroma(theme.palette.common.black).alpha(0.54).css()} videoSegmentStatus={videoCellStatus} />}
    label={
      <Typography
        variant="caption"
        style={{
          fontSize: labelStyles.fontSize,
          lineHeight: labelStyles.lineHeight,
          wordBreak: labelStyles.wordBreak,
          whiteSpace: labelStyles.whiteSpace,
          overflow: labelStyles.overflow,
          textOverflow: labelStyles.textOverflow,
        }}
      >
        {label}
      </Typography>
    }
    size="small"
    sx={sx}
  />;
};
